import React from 'react'
import { connect } from 'react-redux'
import { userRoleSelector } from '@chegg-wt/core/state/user/selectors'
import { UserRole, UserRoles } from '@chegg-wt/core/constants/user'
import { AppState } from '@chegg-wt/core/state'
import { authModalExpFlagSelector } from '@chegg-wt/core/state/createCitation/selectors'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { routeToHref } from '@chegg-wt/core/utils/routes'
import { useRouter } from 'next/router'
import { Config } from '@chegg-wt/core/config'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import {
  UserClickPayload,
  origins,
} from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { startAuthFlow } from '@chegg-wt/core/state/user/actions'
import { AuthPayload } from '@chegg-wt/core/types/auth'
import { AuthModalOrigin } from '../Modals/AuthModal/types'
import * as Styled from './styled'

export const TRY_FOR_FREE_CTA = 'try-for-free-cta-btn'
export const UPGRADE_BAR_TEXT = 'upgrade-bar-test'

export const UpgradeBannerText =
  'All of our citation styles and writing tools, none of the ads'

interface UpgradeBannerProps {
  authModalExpFlag: boolean
  userRole: UserRole
  userClick: (payload: UserClickPayload) => void
  startAuthFlow: (payload: AuthPayload) => void
}

export const UpgradeBanner: React.FunctionComponent<UpgradeBannerProps> = ({
  authModalExpFlag,
  userRole,

  userClick,
  startAuthFlow,
}) => {
  const { toUpgrade } = useRoutesContext()
  const { route } = useRouter()

  const showBanner = route === '/' && Config.flankerSitesBannerCTAUpdate
  const showAuthModal = authModalExpFlag && userRole === UserRoles.NOT_LOGGED_IN

  const freeTrialStartOnClick = () => {
    userClick({ origin: origins.upgradeBannerCTA })
    if (showAuthModal) {
      startAuthFlow({
        defaultFlow: 'signup',
        origin: AuthModalOrigin.HOMEPAGE_UPGRADE_BANNER,
        redirectTo: toUpgrade(),
      })
    } else {
      window.location.href = routeToHref(toUpgrade())
    }
  }
  const ctaText = Config.appName === 'ctfm' ? 'Subscribe Now' : 'Try for free'

  if (userRole !== UserRoles.PRO_USER && showBanner) {
    return (
      <>
        <Styled.Banner>
          <Styled.BoldText data-test={UPGRADE_BAR_TEXT}>
            {UpgradeBannerText}
          </Styled.BoldText>
          <Styled.FreeTrialCTA
            data-test={TRY_FOR_FREE_CTA}
            onClick={freeTrialStartOnClick}
          >
            {ctaText}
          </Styled.FreeTrialCTA>
        </Styled.Banner>
      </>
    )
  }
  return null
}

const mapStateToProps = (state: AppState) => ({
  authModalExpFlag: authModalExpFlagSelector(state),
  userRole: userRoleSelector(state),
})

const mapDispatchToProps = {
  userClick,
  startAuthFlow,
}

export default connect(mapStateToProps, mapDispatchToProps)(UpgradeBanner)
